export default function money(value: unknown): string {
  const numberValue = Number(value);
  if (!value || Number.isNaN(numberValue)) {
    return "";
  }

  const valueInDollars = numberValue / 100;

  const valueDollarsPart = Math.floor(valueInDollars);
  const valueCentsPart = Math.round((valueInDollars - valueDollarsPart) * 100);

  if (valueCentsPart === 0) {
    return `$${valueDollarsPart}`;
  } else if (valueCentsPart < 10) {
    return `$${valueDollarsPart}.0${valueCentsPart}`;
  } else {
    return `$${valueDollarsPart}.${valueCentsPart}`;
  }
}
